import * as React from 'react'
import { bind } from 'classnames/bind'
import * as styles from '@procore/core-css/src/components/_breadcrumbs.scss'

import addSubcomponents from '../utils/addSubcomponents'
import { Props, NavAttributes, SpanAttributes } from '../utils/types'
import Icon from './Icon'

interface BreadcrumbProps extends Props {}

interface BreadcrumbCrumbProps extends Props {
  active?: boolean
}

const cx = bind(styles)

export const Breadcrumbs = React.forwardRef<
  HTMLElement,
  NavAttributes & BreadcrumbProps
>(({ className, children, ...props }, ref) => (
  <nav ref={ref} className={cx('core-breadcrumbs', className)} {...props}>
    {React.Children.toArray(children)
      .filter(child => child)
      .map((child, i) => (
        <React.Fragment key={`separator-${i}`}>
          {i > 0 && (
            <Icon
              className={cx('core-breadcrumbs__separator')}
              icon="chevron-right"
            />
          )}
          {child}
        </React.Fragment>
      ))}
  </nav>
))

export const Crumb = React.forwardRef<
  HTMLSpanElement,
  SpanAttributes & BreadcrumbCrumbProps
>(({ className, children, active, ...props }, ref) => (
  <span
    ref={ref}
    className={cx(
      'core-breadcrumbs__crumb',
      { 'core-breadcrumbs__crumb--active': active },
      className
    )}
    {...props}
  >
    {children}
  </span>
))

Breadcrumbs.displayName = 'Breadcrumbs'

Crumb.displayName = 'Breadcrumbs.Crumb'

export default addSubcomponents(
  {
    Crumb,
  },
  Breadcrumbs
)
